import { notification } from 'antd'

import { Button } from 'components/ui/Button/Button'

import s from './AdminSaveButton.module.scss'

interface AdminSaveButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  text?: string
  showSuccess?: boolean
  onClick: () => void
}

export const AdminSaveButton = ({
  text = 'Сохранить',
  showSuccess = true,
  onClick,
  ...props
}: AdminSaveButtonProps) => {
  const clickHandler = () => {
    onClick()

    if (showSuccess) {
      notification.success({
        message: 'Изменения сохранены!',
      })
    }
  }

  return (
    <div className={s.saveButtonWrap}>
      <Button onClick={clickHandler} {...props} buttonType="slav">
        {text}
      </Button>
    </div>
  )
}
